<template>
  <div class="content">
    <van-nav-bar @click-left="onClickLeft" @click-right="onClickRight" :title="title">
      <template #left>
        <img style="width: 2.66667vw;height: 5.33333vw;display: inline-block;" :src="require('../../assets/'+appTheme+'/navBack.png')" alt="">
      </template>
      <template #right>
        <span>兑换</span>
      </template>
    </van-nav-bar>
    <div class="nav-list-box justify-align">
      <div class="nav-item" @click="clickNav(index)" v-for="(item,index) in navList" :key="index">
        <span :class="[currNav==index?'activeNav':'']">{{item.name}}</span>
        <div class="title-box-line" v-if="currNav==index"></div>
      </div>
    </div>
    <van-list  v-model="loading" :finished="finished" :immediate-check="immediate" :finished-text="finishedTxt" @load="moreList">
      <!--    <div v-if="couponList.length>0">-->
      <!--      <coupon :coupons="couponList" :txtType="1" @sendCoupon="clickCoupon" />-->
      <!--    </div>-->
      <div class="discount-box" v-if="currNav==0">
        <!--     折扣券-->
        <discount :discountList="couponList" :txtType="1" @sendCoupon="clickCoupon" />
      </div>
      <!--    代金券-->
      <div class="coupon-box" v-if="currNav==1">
        <div class="voucher-item-box" v-for="(item,index) in couponList" :key="index">
          <!--  未使用-->
          <div class="voucher-default-box" v-if="item.is_used==0">
            <img class="coupon-item-bg" :src="require('../../assets/'+appTheme+'/voucher_bg.png')" alt="" />
            <div class="voucher-item-content left-justifying" @click="clickCouponDes(item)">
              <div class="price-box">
                <div style="margin-top: 6.66667vw;">￥<span>{{item.amount}}</span></div>
                <div class="voucher-number">券码：{{item.code}}</div>
              </div>
              <div class="center-voucher-box">
                <div class="center-voucher-title left-justifying">
                  <div class="title-txt uni-ellipsis">{{item.title}}</div>
                  <img :src="require('../../assets/'+appTheme+'/voucher_arrow.png')" alt="" />
                </div>
                <div class="voucher-shop uni-ellipsis" v-if="item.shop">店铺：{{item.shop.name}}</div>
                <div class="voucher-shop-des uni-ellipsis">{{item.desc}}</div>
                <div class="voucher-shop-coy">最终解释权归该商家</div>
              </div>
            </div>
            <div class="voucher-is-use-box">
              <div class="voucher-btn-top content-center" @click="clickIsUseSubsidy(item)">
                <div class="voucher-btn-txt">
                  <div>使用</div>
                  <div>立即</div>
                </div>
                <img class="discount_arrow_w" :src="require('../../assets/'+appTheme+'/discount_arrow_w.png')" alt="" />
              </div>
              <div class="voucher-btn-bottom" @click="clickCouponDes(item)">
                <span>有效期至</span>
                <span style="display: block;font-size: 2.4vw;">{{item.use_endtime}}</span>
              </div>
            </div>
          </div>
          <!--  未使用end-->
          <!--  已使用star-->
          <div class="voucher-default-box voucher-default-box2" v-else>
            <img class="coupon-item-bg" :src="require('../../assets/'+appTheme+'/voucher_bg2.png')" alt="" />
            <div class="voucher-item-content left-justifying" @click="clickCouponDes(item)">
              <div class="price-box">
                <div style="margin-top: 6.66667vw;">￥<span>{{item.amount}}</span></div>
                <div class="voucher-number">券码：{{item.code}}</div>
              </div>
              <div class="center-voucher-box">
                <div class="center-voucher-title left-justifying">
                  <div class="title-txt uni-ellipsis">{{item.title}}</div>
                  <img :src="require('../../assets/'+appTheme+'/q_xiala2.png')" alt="" />
                </div>
                <div class="voucher-shop uni-ellipsis" v-if="item.shop">店铺：{{item.shop.name}}</div>
                <div class="voucher-shop-des uni-ellipsis">{{item.desc}}</div>
                <div class="voucher-shop-coy">最终解释权归该商家</div>
              </div>
            </div>
            <div class="voucher-is-use-box">
              <img :src="require('../../assets/'+appTheme+'/is_use_txt.png')" alt="" class="voucher-btn-top-img" />
              <div class="voucher-btn-bottom">
                <span>有效期至</span>
                <span>{{item.use_endtime}}</span>
              </div>
            </div>
          </div>
          <!--  已使用end-->

        </div>
      </div>
      <!--    代金券end-->
      <!--    优先券-->
      <div class="coupon-box" v-if="currNav==2">
        <div class="coupon-item-box" v-for="(item,index) in couponList" :key="index">
          <div class="is-use-box-default" v-if="item.is_used==0">
            <img class="coupon-item-bg" :src="require('../../assets/'+appTheme+'/q_bg.png')" alt="" />
            <div class="coupon-item-content" @click="clickCouponDes(item)">
              <div class="title left-justifying"><div class="title-txt uni-ellipsis">{{item.title}}</div><img :src="require('../../assets/'+appTheme+'/q_xiala.png')" class="q_xiala" /> </div>
              <div class="goods-txt uni-ellipsis">{{item.desc}}</div>
              <div class="date">有效期至{{item.use_endtime}}</div>
              <div class="hint">最终解释权归该商家</div>
            </div>
            <div class="use-box" @click="clickIsUseGoods(item)">
              <div class="use-txt">去使用</div>
              <img :src="require('../../assets/'+appTheme+'/q_arrow.png')" class="use-img" />
              <div class="use-number">券码：{{item.code}}</div>
            </div>
          </div>
          <!--        已使用-->
          <div class="is-use-box-default is-use-box-default2" v-else>
            <img class="coupon-item-bg" :src="require('../../assets/'+appTheme+'/q_bg2.png')" alt="" />
            <div class="coupon-item-content" @click="clickCouponDes(item)">
              <div class="title left-justifying"><div class="title-txt uni-ellipsis">{{item.title}}</div><img :src="require('../../assets/'+appTheme+'/q_xiala2.png')" class="q_xiala" /> </div>
              <div class="goods-txt uni-ellipsis">{{item.desc}}</div>
              <div class="date">有效期至{{item.use_endtime}}</div>
              <div class="hint">最终解释权归该商家</div>
            </div>
            <div class="use-box">
              <img :src="require('../../assets/'+appTheme+'/is_use_txt.png')" class="use-img" />
              <div class="use-number">券码：{{item.code}}</div>
            </div>
          </div>
        </div>
      </div>


    </van-list>
    <!--    输入兑换优惠券弹框-->
    <van-popup round v-model="exchangeShow">
      <div class="popup-box">
        <span class="close-icon"><van-icon name="cross" @click="showContentHide" /> </span>
        <div class="exchange-box">
          <div class="exchange-title">兑换优惠券</div>
          <div class="exchange-hint">请输入优惠券兑换码</div>
          <input v-model="exchangeInput" placeholder="请输入兑换码" type="text" />
        </div>
        <van-button @click="submitExchange" :disabled="disabledExchange" round type="info" style="width:70%;height: 10.66667vw;line-height: 1.33333vw;margin: 2.66667vw auto;display: block;background: #FDD80D;border-color: #FDD80D;color: #282828;">兑换</van-button>
      </div>
    </van-popup>
  </div>
</template>

<script>
// import coupon from "@/components/coupon";
import {collectList, myBonusList,redeemCode} from "@/api/goods";
import discount from "@/components/discount";
export default {
name: "discountCoupon",
  data() {
    return {
      appTheme:this.$store.state.appTheme,
      currNav:0,
      navList:[{type:0,name:'折扣券'},{type:1,name:'代金券'},{type:2,name:'优先券'}],
      couponList: [],
      title:'我的优惠券',
      loading: false, // 加载状态
      finished: false, // 是否加载
      page: 1,
      currentPage: 1,
      immediate: false,
      finishedTxt: '没有更多了~',
      comType:0,
      couponType:'discount', // 类型 discount折扣券 未开发：subsidy代金券 ticket优先券
      exchangeShow:false,
      disabledExchange:false,
      exchangeInput: ''
    }
  },
  components: {
    // coupon,
    discount
  },
  created() {
  this.getCouponList()
  },
  methods: {

    showContentHide(){
      this.exchangeShow = false
      this.exchangeInput = ''
    },
    submitExchange(){ // 兑换
      if (this.exchangeInput == ''){
        this.$toast('请输入兑换码')
        return false
      }else {
        this.disabledExchange = true
        const data = {
          redeem_code: this.exchangeInput
        }
        redeemCode(data).then(res =>{
          if(res.code == 200)
          {
            let data = res.data
            this.$toast(res.message)
            this.exchangeShow = false
            this.disabledExchange = false
            this.exchangeInput = ''
            if (data.type == 'ticket'){ //优先券 类型 discount折扣券 未开发：subsidy代金券 ticket优先券
              this.currNav = 2
              this.couponType = 'ticket'
              this.currentPage = 0
            } else if (data.type == 'subsidy'){
              this.currNav = 1
              this.couponType = 'subsidy'
              this.currentPage = 0
            } else {
              this.currNav = 0
              this.couponType = 'discount'
              this.currentPage = 0
            }
            this.getCouponList()
          }else {
            this.$toast(res.message)
            this.disabledExchange = false
          }

        })
      }

    },
    onClickLeft() { // 后退赋值，因为vue 后退会重新加载
      // var goodsInfo = JSON.stringify(this.goodsInfo)
      // this.$store.commit("setGoodsInfo", goodsInfo);
      // this.$store.commit("setSubmitNumber",this.submitNumber)
      // if (this.payTypeId !=''){
      //   this.$store.commit("setPayTypeId",this.payTypeId)
      // }
      this.$router.go(-1);
    },
    onClickRight() {
      // this.$toast('暂未开放，敬请期待')
      this.exchangeShow = true
    },
    clickNav(index){
      this.currNav = index
      this.comType =index
      if (index==1){
        this.couponType = 'subsidy'
        this.currentPage = 0

      } else if (index==2){
        this.currentPage = 0
        this.couponType = 'ticket'
      } else {
        this.currentPage = 0
        this.couponType = 'discount'
      }
      this.getCouponList()
    },
    getCouponList(){  // 获取商家优惠券
      var that = this
      var data= { // 类型 discount折扣券 未开发：subsidy代金券 ticket优先券
        type:this.couponType
      }
      myBonusList(data).then(res => {
        if(res.code == 200)
        {
          this.couponList = res.data.data
          // 加载状态结束
          that.loading = false;
          if (res.data.data.length == res.data.total){ // 数据全部加载完
            that.finished = true; // 数据全部加载完
            if(res.data.data == ''){
              that.finishedTxt = '暂无数据~'
            } else {
              that.finishedTxt = '没有更多了~'
            }
          }else {
            that.finished = false; // 不可以加载
          }
        }
        else
        {
          this.$toast(res.message)
        }
      })
    },
    clickCoupon(item,index){ // 领取优惠券 多个值，用逗号隔开
      // console.log('item',item)
      console.log('index',index)
      var obj = JSON.stringify(item)
     this.$router.push({path: 'couponDes',query: {item:obj,comType:this.comType}})

    },
    clickCouponDes(item){
      var obj = JSON.stringify(item)
      this.$router.push({path: 'couponDes',query: {item:obj,comType:this.comType}})
    },
    clickIsUseSubsidy(item){
      if(item.shop==null){
        this.$router.push({path:'/goodClassify'})
      } else {
        this.$router.push({path:'/shopDes',query: {id:item.shop.id}})
      }
    },
    clickIsUse(item){
      this.$router.push({path:'/shopDes',query: {id:item.shop.id}})
    },
    clickIsUseGoods(item){ // 一元秒杀商品
      let pro_id = item.one_pay_goods.id // 项目id   useful_stock 库存
      this.$router.push({path:'/goodDetails',query:{id:item.one_pay_goods.goods_id,type:pro_id,isPay:item.one_pay_goods.useful_stock}})
    },
    moreList(){
      var that = this
      this.currentPage += 1;//页数+1
      var data = {
        page:this.currentPage
      }
      myBonusList(data).then(res => {
        if(res.code == 200)
        {
          var arr = this.couponList.concat(res.data.data);
          // console.log(arr.length)
          that.couponList = arr
          // 加载状态结束
          this.loading = false;
          if (that.couponList.length == res.data.total) { // 数据全部加载完成
            this.finished = true;
            // console.log('加载完毕')
          } else {
            this.finished = false;
          }
        }
        else
        {
          this.$toast(res.message)
          // this.$router.push('/');
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.van-popup--center {
  top: 34%;
}
.popup-box{
  padding: 30px 30px 30px;width: 500px;
  position: relative;
  .exchange-box{
    text-align: center;
    .exchange-title{
      font-size: 32px;font-weight: bold;margin-top: 30px;margin-bottom: 20px;
    }
    input{
      width: 90%;height: 60px;line-height: 60px;margin: 30px auto 20px;padding: 0 10px;
    }
  }
  .top-box{
    text-align: center;font-size: 30px;
  }
  .tx-box{
    text-align: center;font-weight: bold;font-size: 60px;padding: 40px 0 20px;
    border-bottom: 2px solid #F5F5F5;margin-bottom: 20px;
    .popup-number{
      margin-top: 20px;
    }
    span{
      font-size: 28px;font-weight: normal;
    }
  }
  .close-icon{
    position: absolute;left: 30px;top: 20px;font-size: 40px;
  }

}
.van-hairline--bottom::after {
  border-bottom-width: 0;
}
.van-nav-bar {
  background: #FDD80D;color: #333333;font-weight: bold;font-size: 30px;
}
.van-nav-bar .van-icon {
  color: #333333;
}
.nav-list-box{
  background: #FFFFFF;
  .nav-item{
    width: 33.3%;padding: 30px 0;font-size: 30px; position: relative;text-align: center;
    span{
      position: relative;z-index: 2;
    }
    .activeNav{
      position: relative;
    }
    .title-box-line{
      height: 12px;width: 104px;
      background: #FDD80D;
      border-radius: 6px;margin: -10px auto 0;
    }

  }

}
.coupon-box{
  .is-use-box-default{
    position: relative;
  }
  .coupon-item-box{
   width: 716.9px;margin: 28px auto 0;
    position: relative;
    .coupon-item-bg{
      width: 716.9px;height: auto;display: block;margin: 0 auto;
    }
    .coupon-item-content{
      position: absolute;z-index: 2;width: 460px;left: 60px;top: 40px;text-align: left;
      .title{
        margin-bottom: 14px;
      }
      .title-txt{
        font-weight: bold;
        color: #E9740B;font-size: 32px; width: 80%;
      }
      .q_xiala{
        width: 12px;height: auto;display: inline-block;margin-left: 20px;
      }
      .goods-txt{
        background: #FFF0E5;
        border-radius: 19px;font-size: 22px;font-weight: 400;
        color: #E9740B;display: inline-block;padding: 2px 10px;
        width: 80%;
      }
      .date{
        color: #E9740B;font-size: 20px;margin-bottom: 8px;
      }
      .hint{
        font-size: 20px;
        font-weight: 400;
        color: #9E9E9E;
      }
    }
    .is-use-box-default2{
      .title-txt{
        color: #8C8787;
      }
      .goods-txt{
        color: #8C8787;background: #E6E6E6;
      }
      .date{
        color: #8C8787;
      }
      .use-img{
        width: 132px;height: auto;
        display: block;margin: 0 auto 10px;
      }
    }
    .use-box{
      position: absolute;z-index: 2;right: 0;top: 40px;width: 190px;text-align: center;
      .use-txt{
        font-size: 36px;color: #FFFFFF;
      }
      .use-number{
        font-size: 18px;color: #FFFFFF;
      }
      img{
        width: 48px;height: auto;display: block;margin: 20px auto 30px;
      }
    }
  }

}
.voucher-item-box{
  margin:28px 20px 0;position: relative;
  .voucher-default-box{
    .coupon-item-bg{
      width: 100%;display: block;height: auto;
    }
    .voucher-item-content{
      position: absolute;width:500px;height: auto;left: 20px;top: 30px;
      .price-box{
        font-size: 29px;
        font-weight: bold;padding-right: 10px;
        color: #F34B09;width: 200px;text-align: center;height: 180px;
        span{
          font-size: 50px;
        }
        .voucher-number{
          font-weight: 400;
          color: #FF953A;font-size: 18px;position: absolute;bottom: 10px;left: 20px;
        }
      }
      .center-voucher-box{
        width: 310px;
        .center-voucher-title{
width: 100%;
          .title-txt{
            overflow: hidden;
            font-size: 28px;
            font-weight: bold;
            color: #E9400B;width: 70%;
          }
          img{
            width: 12px;display: inline-block;height: auto;
          }
        }
        .voucher-shop{
          width: 234px;
          overflow: hidden;color: #FB6666;font-size: 22px;
          background: #FFF0E5;text-align: center;
          border-radius: 19px;margin: 10px 0;padding: 5px 5px;text-align: left;
        }
        .voucher-shop-des{
          font-size: 22px;font-weight: 400;margin: 10px 0;
          color: #9E9E9E;width: 80%;overflow: hidden;
        }
        .voucher-shop-coy{
          font-size: 20px;font-weight: 400;
          color: #9E9E9E;
        }
      }
    }
    .voucher-is-use-box{
      position: absolute;width: 190px;height: auto;right: 0;top: 0;text-align: center;
      .voucher-btn-txt{
        font-size: 36px;font-weight: 400;margin-top: 20px;
        color: #FFFFFF;
      }
      .discount_arrow_w{
        width: 48px;height: auto;display: inline-block;margin-left: 10px;
      }
      .voucher-btn-bottom{
        font-size: 22px;
        font-weight: 400;
        color: #FFFFFF;margin-top: 20px;
        line-height: 40px;
      }
    }
  }
  .voucher-default-box2{
    .voucher-item-content{
      .price-box{

        color: #8C8787;
        .voucher-number{
          color: #8C8787;
        }
      }
      .center-voucher-box{

        .center-voucher-title{

          .title-txt{

            color: #8C8787;width: 70%;
          }

        }
        .voucher-shop{
          color: #8C8787;
          background: #E6E6E6;
        }
        .voucher-shop-des{

          color: #9E9E9E;
        }
        .voucher-shop-coy{
          font-size: 20px;font-weight: 400;
          color: #9E9E9E;
        }
      }
    }

    .voucher-is-use-box{
      .voucher-btn-top-img{
        width: 132px;display: block;margin:20px auto 5px;height: auto;
      }
      .voucher-btn-bottom{
        margin-top: 0;line-height: 35px;
      }
    }

  }
}
</style>
